import React from "react";

import { useTechBreak } from "./hooks";

export const TechBreak = React.memo(() => {
  const { getTechBreakProps } = useTechBreak();
  return (
    <div {...getTechBreakProps()}>
      <span>ДАЛЕЕ ТЕХ. ПЕРЕРЫВ</span>
      <span>СКОРО ВЕРНЕМСЯ</span>
    </div>
  );
});

TechBreak.displayName = "TechBreak";
